








import { defineComponent, onMounted, ref, watch, reactive } from '@vue/composition-api';
import { isCore } from '@/useable/login';

export default defineComponent({
  name: 'Breadcrumb',
  setup(prop: any, { root }) {
    // todo
    const breadcrumbArr: any = ref([]);
    const routeObj: any = reactive({name:''});
    // console.log(root.$router.getMatchedComponents());
    const getBreadcrumb = () => {
      const { matched } = root.$route;
      const arr = matched.map((item) => {
        return {
          path: item.path,
          name: item.meta.title
        };
      }).filter(item => item.name && item.name !== '首页' );
      if (arr && arr.length>0 && arr[0].name === '数据统计'){
        routeObj.name = isCore.value?'核心企业':'供应商';
        arr.push(routeObj);
      }
      breadcrumbArr.value = arr;
    };

    watch(()=> root.$route, ()=>{
      getBreadcrumb();
    });
    onMounted( getBreadcrumb);
    return {
      breadcrumbArr
    };
  },
});
